module.exports = __webpack_public_path__ + "static/media/monsterfoods.474fa8ab.png";